import script from "./CalculationAsemblyItems.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculationAsemblyItems.vue?vue&type=script&setup=true&lang=js"

import "./CalculationAsemblyItems.vue?vue&type=style&index=0&id=a120a08a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a120a08a"]])

export default __exports__